


























import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Axios from 'axios'

interface ICancelReason {
  label: string
  showNotes: boolean
}

@Component({})
export default class SubscriptionCancelModal extends Vue {
  @Prop()
  active: boolean

  open: boolean = this.active
  loading: boolean = false

  cancelReason: ICancelReason | null = null
  cancelNotes: string = ''
  allowContact: boolean = true

  reasonOptions: ICancelReason[] = [
    {
      label: 'Just wanted to convert my library',
      showNotes: false
    },
    {
      label: 'Only wanted to clean & fix my library once',
      showNotes: false
    },
    {
      label: 'Missing a certain feature',
      showNotes: true
    },
    {
      label: 'Did not meet my expectations',
      showNotes: true
    },
    {
      label: 'Other',
      showNotes: true
    }
  ]

  async cancelSubscription() {
    this.loading = true

    try {
      const reason: string = this.cancelReason ? this.cancelReason.label : ''
      let notes: string = this.cancelNotes
      let allowContact: boolean = this.allowContact

      if (!this.cancelReason || (this.cancelReason && !this.cancelReason.showNotes)) {
        notes = ''
        allowContact = false
      }

      await Axios.post('/user/cancel-subscription', {
        canceled: true,
        reason,
        notes,
        allowContact
      })

      this.$store.commit('subscription/reset')
      await this.$store.dispatch('subscription/fetchStatus')

      this.$buefy.notification.open('Your subscription has been canceled')

      this.open = false
    } catch (error) {
      window.alert(`Something went wrong. Send me a message and I'll get this sorted right away!`)

      throw error
    } finally {
      this.loading = false
    }
  }

  @Watch('active')
  updateOpen(v: boolean) {
    this.open = v
  }

  @Watch('open')
  emit(v: boolean) {
    this.$emit('update:active', v)
  }
}
